import { lazy } from 'react';
import { UserTypes } from '@/configs/AppConfig';
import { MOD_AUTH } from "@/configs/ModulesConfig" 
const AppUserLogin = lazy(() => import('./app-user/AppUserLogin'));
const SystemUserLogin = lazy(() => import('./system-user/SystemUserLogin'));


const route = [
    {
        path: MOD_AUTH.app_user_log_in_path,
        element: <AppUserLogin />,
        auth: MOD_AUTH.auth
    },
    {
        path: MOD_AUTH.system_user_log_in_path,
        element: <SystemUserLogin />,
        auth: MOD_AUTH.auth
    },
    // {
        
    // }
];



export default route;